module.exports = __webpack_public_path__ + "static/img/me-img4.3a2c0d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me-img4.png
// module id = gwrQ
// module chunks = 0